<template>
  <div class="start view">
  	<overlay v-if="$store.state.overlay !== null"></overlay>
    <menu-desktop></menu-desktop>
    <menu-mobile></menu-mobile>
    <splash></splash>
    <products></products>
    <feed></feed>
    <footern></footern>
  </div>
</template>

<script>
import Feed from '@/components/Feed'
import Splash from '@/components/Splash'
import MenuDesktop from '@/components/MenuDesktop'
import MenuMobile from '@/components/MenuMobile'
import Products from '@/components/Products'
import Overlay from '@/components/Overlay'
import Footern from '@/components/Footern'
export default {
  name: 'start',
  components: { Feed, Splash, MenuDesktop, Products, Overlay, MenuMobile, Footern }
}
</script>

<style>
  .menu-desktop {
    display: block;
  }
  .menu-mobile {
    display: none;
  }
@media only screen and (max-width: 900px) {
  .menu-desktop {
    display: none;
  }
  .menu-mobile {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// Start.vue?b2ea361c